type Props = {
  constatsCount: number;
  constatsClosedCount: number;
};

function getStyle() {
  return {
    backgroundColor: "var(--grey-bg)",
    color: "var(--grey-text)",
    borderRadius: "20px",
    padding: "5px 20px",
    display: "inline-block",
    whiteSpace: "nowrap" as const,
    fontSize: "14px",
  };
}

const BadgeConstatsCount: React.FC<Props> = ({
  constatsCount,
  constatsClosedCount,
}) => {
  return (
    <span style={getStyle()}>
      {constatsClosedCount} / {constatsCount}
    </span>
  );
};

export default BadgeConstatsCount;
